import { render } from "./LabdaqPendingOrders.vue?vue&type=template&id=f3fbeb2e"
import script from "./LabdaqPendingOrders.vue?vue&type=script&lang=js"
export * from "./LabdaqPendingOrders.vue?vue&type=script&lang=js"

import "./LabdaqPendingOrders.vue?vue&type=style&index=0&id=f3fbeb2e&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/LabdaqPendingOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3fbeb2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3fbeb2e', __exports__)) {
    console.log('reload')
    api.reload('f3fbeb2e', __exports__)
  }
  
  module.hot.accept("./LabdaqPendingOrders.vue?vue&type=template&id=f3fbeb2e", () => {
    console.log('re-render')
    api.rerender('f3fbeb2e', render)
  })

}


export default __exports__